import { ProductAddCommandModel } from "../product-base-model";

export class TransportAddCommandModel extends ProductAddCommandModel {
    public productScheduleVersionId: string;
    public vehicleTypeCode: string;
    public vehicleId: string;
    public vehicleCompositionId: string;
    public usageTypeCode: string;
}